import { useQuery } from "@tanstack/react-query"
import { getProductById } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductDetails(productId: string | null | undefined) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["product", productId],
    queryFn: () => getProductById(productId!, accessToken ?? undefined),
    enabled: !!productId,
    staleTime:0,
  })
}